import { useCallback } from 'react';
import { useApplicationOperations } from '../hooks';

export const useGetUserGeolocation = () => {
  const { setErrorNotice } = useApplicationOperations();

  const getUserGeolocation = useCallback(() => new Promise<GeolocationPosition>((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      resolve,
      (error) => {
        if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
          setErrorNotice({ translateId: 'userGeolocation.permissionDenied' });
        } else if (error.code === GeolocationPositionError.TIMEOUT) {
          setErrorNotice({ translateId: 'userGeolocation.timeout' });
        } else if (error.code === GeolocationPositionError.POSITION_UNAVAILABLE) {
          setErrorNotice({ translateId: 'userGeolocation.positionUnavailable' });
        }

        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    )
  }), [setErrorNotice]);

  return getUserGeolocation;
};
